<template>
    <div id="menu">
        <div id="menu-header">
            <div class="logo-container-container">
                <div class="logo-container">
                    <div class="logo"></div>
                </div>
            </div>
            <img class="logotipo" :src="logoPath" />
        </div>
        <div id="menu-screen-list">
            <div v-for="screen in screens" v-bind:key="screen.menuKey"  class="button" @click="redirect(screen)"
            :class="{'active':screen.menuKey == activeScreen}">
                <div class="button-content">
                    <div v-if="typeof screen.menuLogo == 'string'" class="button-icon">
                        <i class="fas" :class="'fa-'+screen.menuLogo"></i>
                    </div>
                    <div v-else-if="Array.isArray(screen.menuLogo)" class="button-icon"
                        style="display: flex; justify-content: space-evenly; max-width: 70%; margin:auto"
                    >
                        <i v-for="(icon, index) in screen.menuLogo" v-bind:key="index" 
                            class="fas" :class="'fa-'+icon"
                            
                            >
                        </i>
                    </div>
                    <div class="button-label">{{t(screen.label)}}</div>
                </div>
            </div>
        </div>
        <div id="menu-footer">
            <div v-for="action  in footerActions" 
                v-bind:key="action.name" 
                class="button"
                @click="onClickHandler(action.onClick)">
                <i class="icon fas" :class="'fa-'+action.logo"></i>
                {{action.label}}
            </div>
        </div>
        <img class="poweredBy" src="../../../static/desenvolvidoTeknisa.svg" />
        <div class="app-version">v {{ appVersion }}</div>
    </div>
</template>

<script>
import LoginService from '@/application/services/Login'
import permissionManager from '@/application/libs/permissionManager'
import { t } from 'i18next'
// import ProdENV from '../../../config/prod.env.js';

export default {
    name:"MenuComponent",
    data(){
        return {
            // screenList: this.$router.options.routes.filter(route=>route.showOnMenu),
            footerActions: [
                {
                    name:"logout",
                    label:t('leave'),
                    logo:"power-off",
                    onClick: this.doLogout
                }
            ],
            activeScreen: null,
            appVersion: process.env.APP_VERSION || '1.0.0'
        }
    },
    computed: {
        screens: function(){
            const permissions = permissionManager.getMenuAccess();
            return this.$router.options.routes.filter(route => route.showOnMenu && permissions[route.path]);
        },
		logoPath() {
	   	if (localStorage.getItem('lang') === 'es-CL') {
	      	return "@/../static/bo-logotipo-es.png";
	      } else if(localStorage.getItem('lang') === 'en-US') {
	        return "@/../static/bo-logotipo-en.png";
	      }else{
	      	return "@/../static/bo-logotipo-pt.png";
	      }
	   }        
    },
    methods:{
        redirect: function(screen){
            if(this.$router.currentRoute.path!=screen.path){
                localStorage.setItem('activeScreen', screen.menuKey);
                this.$router.push(screen.path);
            }else{
                window.location.reload();
            }
        },
        onClickHandler(onClick){
            if(onClick){
                onClick(this);
            }
        },
        doLogout(){
            this.$modal.show({
                template:`
                    <div class="confirmation-dialog-box">
                        <h5 class="title">{{$t('changes_may_be_not_saved')}}<br>{{$t('do_you_really_want_to_leave')}}</h5>
                        
                        <div class="dialog-button-container">
                            <button class="confirmation-dialog-button" @click="close"> {{$t('cancel')}} </button>
                            <button class="confirmation-dialog-button" @click="logout"> {{$t('leave')}} </button>
                        </div>
                    </div>
                `,
                methods:{
                    logout(){
                        LoginService.doLogout(this);
                    },
                    close(){
                        this.$emit('close');
                    }
                }
            }, {}, {
                //Modal properties
                height:'150px',
                width:'400px',
                resizable:false
            })
        },
        t(value) {
            return t(value);
        }
    },
    mounted(){
        this.activeScreen = this.$router.currentRoute.path.replace('/','');
    }
}
</script>

<style lang="less">
@import (reference) url("../../assets/variables.less");

#menu {
    .user-not-select;
    position: relative;
    background-color: #212146;
    max-width: 100px;
    height: 100vh;

    #menu-header {
        margin-top: 15px;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 0;

        * {
            margin: 1px;
        }

        .logo-container-container {
            height: 65px;
            .logo-container {
                .logo {
                    position: relative;
                    display: table;
                    width: 50px;
                    height: 50px;
                    background: url('../../../static/bo-icone.svg') center center;
                }
            }
        }

        .logotipo {
            max-width: 100%;
            display: inline-block;
            vertical-align: middle;
            filter: drop-shadow(-2px 4px 6px black);
            margin-bottom: 5px; /* Reduz espaço abaixo da logo */
        }

        h4 {
            display: inline-block;
            vertical-align: middle;
            font-size: 0.85rem;
            color: white;
            text-shadow: -2px 4px 6px black;
        }
    }

    #menu-screen-list {
        margin-top: 15px;
        height: calc(100vh - 214px); /* Ajuste da altura para incluir versão */
        overflow: hidden auto;
    }

    #menu-footer {
        position: absolute;
        display: block;
        width: 100%;
        bottom: 60px; /* Empurra o botão de logout para cima */
        
        .button {
            height: auto;
            display: block;
            padding: 2px 0;
            font-size: 0.9rem;

            .icon {
                color: @vermelho;
            }

            &:hover {
                .icon {
                    color: white;
                }

                background-color: #8a0b25;
            }
        }
    }

    .button-content {
        display: table;
        margin: auto;
        div {
            display: block;
        }
    }

    .button {
        display: flex;
        .clicavel;
        background-color: transparent;
        box-shadow: none;
        text-align: center;
        border: none;
        color: #9f9f9f;
        padding: 0;
        height: 65px;

        &:hover {
            color: white;
        }

        &.active {
            color: white;
            background-color: @vermelho;
        }

        .button-icon {
            font-size: 1.5rem;
        }

        .button-label {
            font-size: 11px;
            max-width: 99.4%;
            text-align: center;
            margin: auto;
        }
    }

    .poweredBy {
        display: block;
        position: absolute;
        bottom: 30px; /* Ajuste para acomodar versão abaixo */
        left: 5px;
        right: 5px;
        max-width: calc(100% - 5px);
    }

    .app-version {
        position: absolute;
        bottom: 5px; /* Logo abaixo de "powered by" */
        left: 5px;
        right: 5px;
        text-align: center;
        font-size: 0.75rem;
        color: white;
        opacity: 0.8; /* Deixa o texto levemente menos destacado */
    }
}
</style>